import React from 'react';

const inches = mm => Number.isFinite(mm) ? `${(mm / 25.4).toFixed(1)} in` : 'Unavailable';
const height = (value, unit) => Number.isFinite(value) ? `${Math.round(value)} ${unit}` : 'Unavailable';

export default function BenchmarkDiagnostics({ benchmark, diagnostics }) {
  if (!benchmark || !diagnostics || diagnostics.benchmarkId !== benchmark.id || !diagnostics.cases.length) return null;
  const errors = benchmark.cases.filter(row => row.status === 'scored')
    .sort((a, b) => Math.abs(b.errorMm) - Math.abs(a.errorMm)).slice(0, 3);
  return <section className="rekkie-snow-stations" aria-label="Forecast error investigation">
    <h3>Forecast error investigation</h3>
    <p>Three largest absolute errors in this station sample. Forecast scores still use the original nearest grid cell.</p>
    {errors.map(row => {
      const context = diagnostics.cases.find(item => item.caseId === row.caseId);
      return <article className="rekkie-snow-station" key={row.caseId}>
        <h4>{row.date} · error {inches(row.errorMm)}</h4>
        {!context || context.status !== 'captured' ? <p>Terrain diagnostic unavailable{context?.reason ? `: ${context.reason}` : '.'}</p> : <>
          <p>Station elevation {height(context.stationElevationM, 'm')} · Model terrain {height(context.modelTerrainGpm, 'gpm')} · Approximate gap {height(context.approximateHeightGapM, 'm')}</p>
          <div className="rekkie-snow-table-wrap"><table>
            <thead><tr><th>Nearest-cell forecast</th><th>Surrounding-cell range</th><th>Measured snowfall</th></tr></thead>
            <tbody><tr><td>{inches(row.forecastMm)}</td><td>{inches(context.minSnowfallMm)} to {inches(context.maxSnowfallMm)} ({context.validCellCount}/4 valid cells)</td><td>{inches(row.observedMm)}</td></tr></tbody>
          </table></div>
          <details><summary>Grid cells and terrain source</summary>
            <p>Model heights use geopotential metres (gpm). Station vertical references remain unverified; the height gap is approximate.</p>
            <p>The surrounding-cell range describes spatial variation. It is not a calibrated forecast interval.</p>
            <div className="rekkie-snow-table-wrap"><table>
              <thead><tr><th>Cell</th><th>Distance</th><th>Terrain</th><th>Snowfall</th></tr></thead>
              <tbody>{context.cells.map(cell => <tr key={cell.gridIndex}><th scope="row">{cell.gridIndex}{cell.nearest ? ' · nearest' : ''}</th><td>{cell.distanceKm.toFixed(2)} km</td><td>{height(cell.modelTerrainGpm, 'gpm')}</td><td>{cell.status === 'valid' ? inches(cell.snowfallMm) : cell.reason}</td></tr>)}</tbody>
            </table></div>
            <a href={`${context.terrainSource.url}.idx`} target="_blank" rel="noreferrer">NOAA terrain inventory ↗</a>
          </details>
        </>}
      </article>;
    })}
  </section>;
}
